import React from 'react';
import { Code, Database, Cloud, Globe } from 'lucide-react';

const TechStack = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">
            Notre Stack Technique
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Des technologies modernes et éprouvées pour votre succès
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          <div className="p-6 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors duration-300">
            <Code className="w-12 h-12 text-orcsys-500 mx-auto mb-4" />
            <h3 className="font-semibold text-slate-900 mb-2">Frontend</h3>
            <p className="text-sm text-slate-600">
              React, Next.js, TypeScript, Tailwind CSS
            </p>
          </div>
          <div className="p-6 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors duration-300">
            <Database className="w-12 h-12 text-orcsys-500 mx-auto mb-4" />
            <h3 className="font-semibold text-slate-900 mb-2">Backend</h3>
            <p className="text-sm text-slate-600">
              Django, Node.js, GraphQL
            </p>
          </div>
          <div className="p-6 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors duration-300">
            <Cloud className="w-12 h-12 text-orcsys-500 mx-auto mb-4" />
            <h3 className="font-semibold text-slate-900 mb-2">Cloud</h3>
            <p className="text-sm text-slate-600">
              AWS, Vercel, Docker, Kubernetes
            </p>
          </div>
          <div className="p-6 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors duration-300">
            <Globe className="w-12 h-12 text-orcsys-500 mx-auto mb-4" />
            <h3 className="font-semibold text-slate-900 mb-2">DevOps</h3>
            <p className="text-sm text-slate-600">
              CI/CD, Monitoring, Tests Automatisés
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack; 